var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RadioGroup',{staticClass:"yesno-radio-grp",attrs:{"value":_vm.value,"items":_vm.items,"asterisk":_vm.asterisk,"required":_vm.required},on:{"input":function($event){return _vm.handleInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }